export const CurrenciesEnum = {
    AUD: "AUD",
    USD: "USD",
    NZD: "NZD",
    CAD: 'CAD'
}